import i18next from 'i18next'
import { matchPath, To } from 'react-router'

import { defaultLang } from 'config'

export const getPathWithoutI18nPrefix = (path: string) =>
  path.replace(/^\/(ja|id|th|en|ko|zh-CN|zh-HK)/, '')

export const getI18nPath = (
  path: To = '',
  language = i18next.language ?? defaultLang
) => {
  const pathString = typeof path === 'string' ? path : path.pathname
  const pathWithoutI18nPrefix = getPathWithoutI18nPrefix(pathString)

  if (language === defaultLang) {
    return combinePath(pathWithoutI18nPrefix, path)
  } else if (pathString.startsWith(`/${language}`)) {
    return combinePath(pathString, path)
  }

  return combinePath(`/${language}${pathWithoutI18nPrefix}`, path)
}

const combinePath = (path: string, pathDetail: To) => {
  if (typeof pathDetail === 'string') return path

  return `${path}${pathDetail.search ?? ''}${pathDetail.hash ?? ''}`
}

export const matchI18nPath = (
  path: string,
  options: {
    pathname?: string
    startsWith?: boolean
  } = {}
) => {
  const i18nPath = getI18nPath(path)

  return matchPath(
    { path: i18nPath, end: !options.startsWith },
    options.pathname ?? window.location.pathname
  )
}

export const matchI18nPathList = (
  pathList: string[],
  options?: Parameters<typeof matchI18nPath>[1]
) => {
  return pathList.some((path) => matchI18nPath(path, options))
}
